import i18next from 'i18next';

{
  const btnArr = document.querySelectorAll('.js-show-more-btn');

  btnArr.forEach((btn) => {
    const hiddenBlock = btn.parentElement.querySelector('.js-show-more-block');
    let isHidden = true;
    btn.addEventListener('click', () => {
      isHidden = !isHidden;
      const btnTitle = isHidden ? 'SHOW_MORE' : 'HIDE_MORE';
      btn.innerText = i18next.t(btnTitle);
      hiddenBlock.classList.toggle('hidden');
    })
  })
};

{
  const headingsBlocks = [...document.querySelectorAll('.js-equal-heading-block')];

  const headingsArr = headingsBlocks.reduce((prev, curr) => {
    return [...prev,
      [...curr.querySelectorAll('.js-equal-heading')]
    ]
  }, []);

  function setEqualHEadingHeight(headings) {
    headings.forEach((heading) => heading.style.minHeight = 'auto');
    const heightArr = headings.map((heading) => heading.offsetHeight);
    const maxHeight = Math.max.apply(null, heightArr);
    headings.forEach((heading) => heading.style.minHeight = `${ maxHeight }px`)
  }

  i18next.on('languageChanged', () => {
    setTimeout(() => {
      headingsArr.forEach((headings) => {
        setEqualHEadingHeight(headings);
      });
    }, 500);
  });

  window.addEventListener('resize', () => {
    headingsArr.forEach((headings) => {
      setEqualHEadingHeight(headings);
    });
  });
}